<template>
  <div>
    <z-dialogo
      ref="dialogo"
      titulo="ESCOLHER VARIAÇÃO"
      scrollable
      dividers
      no-padding
      largura="600px"
      altura="300px"
      persistent
    >
      <template v-slot:prepend>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{ produto.descricao }}</v-toolbar-title>
        </v-toolbar>
      </template>
  
      <template v-slot:conteudo>
        <z-splitter left-width="40%" hide-left_>
  
          <template v-slot:panel1>
            <v-card tile flat class="d-flex flex-column fill-height">
              <v-card-text ref="cardScroll" class="pa-0 fill-height nice-scrollbar">
    
                <v-list dense nav>
                  <v-subheader>Variações</v-subheader>
                  <v-list-item-group mandatory v-model="variacao_selecionada" color="primary">
                    <template v-for="(variacao, index) in produto.variacoes">
                      <v-list-item :key="index" @click="onVariacaoClick(variacao)">
                        <v-list-item-content>
                          <v-list-item-title class="text-uppercase" v-text="variacao.descricao"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
  
              </v-card-text>
            </v-card>
  
          </template>
            
          <template v-slot:panel2>
            <v-card tile flat class="d-flex flex-column fill-height">
              <v-card-text class="pa-0 fill-height nice-scrollbar">
                
                <v-list dense nav v-if="!!variacao">
                  <v-subheader>Opções</v-subheader>
                  <v-list-item-group mandatory v-model="valor_selecionado" color="primary">
                    <template v-for="(valor, index) in variacao.valores">
                      <v-list-item :key="index" @click="onValorClick(valor)">
                        <v-list-item-content>
                          <v-list-item-title class="text-uppercase" v-text="valor.descricao"></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
  
              </v-card-text>
            </v-card>
          </template>
        </z-splitter>
      </template>
  
      <template #append>
        <div class="pa-4">
          <div class="px-2 text-right text-body-2">
            Estoque Atual: {{ produto.estoque }} (F2 - Exibir)
          </div>
          <v-row dense>
            <v-col cols="12" style="min-height: 100px">
              <v-form ref="form" v-model="form_valido" lazy-validation>
                <z-campo-valor
                  v-model="quantidade"
                  ref="quantidade"
                  name="quantidade"
                  label="Quantidade"
                  decimais="0"
                  filled
                  dense
                  autofocus
                  append-icon="mdi-view-list"
                  :hide-details="!error"
                  :rules="[rules.minNumber]"
                  @keyup.enter="confirmar"
                  @click:append="exibirEntradas(produto)"
                  @keyup.f2="exibirEntradas(produto)"
  
                ></z-campo-valor>
              </v-form>
  
              <div class="mt-2">
                <v-chip
                  v-for="(valor, index) in valores_selecionados"
                  :key="index" 
                  small 
                  close 
                  class="mr-2"
                  @click:close="removerValor(index)"
                >{{ valor.descricao }}</v-chip>
              </div>
              <div v-if="error">
                <v-alert
                  outlined
                  type="error"
                  text
                >
                  Selecione todas as variações antes de confirmar
                </v-alert>
              </div>
            </v-col>
          </v-row>
        </div>
      </template>
  
      <template v-slot:actions_right>
        <v-btn text color="primary" @click="cancelar">Cancelar (ESC)</v-btn>
        <v-btn depressed color="primary" @click="confirmar" :disabled="!form_valido">Confirmar (ENTER)</v-btn>
      </template>
  
      
    </z-dialogo>
    
    <dialogo-exibir-entradas ref="dialogoExibirEntradas" @selecionar:grade="selecionaGradeDasEntradas"></dialogo-exibir-entradas>
  </div>
</template>

<script>
  import DialogoExibirEntradas from "@/pages/produtos/DialogoExibirEntradas";

  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  export default {
    name: 'SelecionarVariacao',

    components: {
      DialogoExibirEntradas,
    },

    props: {
      produto: {
        type: Object,
      },
    },

    // mounted() {
    //   this.abrir();
    // },

    data() {
      return {
        form_valido: true,
        dialog: true,
        variacao_selecionada: 0,
        valor_selecionado: 0,
        valores_selecionados: [],
        quantidade: 1,
        variacao: null,
        error: false,

        rules: {
          minNumber: v => v >= 1 || 'Valor mínimo 1',
        },
      }
    },

    computed: {
      name() {
        return this.dialog;
      },

      valores() {
        if (this.produto.variacoes) {
          return this.produto.variacoes[this.variacao_selecionada].valores;
        }

        return [];
      }
    },

    methods: {
      init() {
        
        this.variacao_selecionada = 0;
        this.variacao = this.produto.variacoes[0];
        this.onVariacaoClick(this.variacao);

        if (!this.produto.grade) {
          this.valor_selecionado = 0;
          this.quantidade = 1;
          this.error = false;
          this.valores_selecionados = [];
          // this.valores_selecionados = this.produto.variacoes.map(variacao => variacao.valores[0]);
        }

        document.addEventListener('keyup', this.onPressESC);
      },

      abrir() {
        this.init();
        this.$refs.dialogo.abrir();
        // this.variacao = this.produto.variacoes[0];
        // this.variacao_selecionada = 0;
      },

      fechar() {
        document.removeEventListener('keyup', this.onPressESC);
        this.$refs.dialogo.fechar();
      },
      
      cancelar() {
        this.fechar();
        this.$emit('cancelar');
      },

      confirmar() {
        this.error = false;

        if (this.valores_selecionados.length != this.produto.variacoes.length) {
          this.error = true;
          return;
        }

        
        const variacao = {
          variacao: this.variacao,
          grade: this.valores_selecionados,
          quantidade: this.quantidade,
        };
        
        console.log({...variacao});
        
        this.$emit('selecionar:variacao', variacao);
        this.fechar();
      },

      onVariacaoClick(variacao) {
        this.error = false;
        this.variacao = variacao;

        // console.log({...variacao});
        // console.log({...this.valores_selecionados});

        if (this.valores_selecionados.length === 0) {
          return false;
        }

        const valor_selecionado = this.valores_selecionados.find(valor => valor.variacao_id === variacao.id);

        if (valor_selecionado) {
          this.valor_selecionado = variacao.valores.findIndex(valor => valor.id === valor_selecionado.id);
        } else {
          this.valor_selecionado = 0;
        }

        // console.log({...valor_selecionado});

        if (this.produto.variacoes.length == this.valores_selecionados.length) {
          this.$refs.quantidade.focus();
        }
      },

      onValorClick(valor) {
        this.error = false;

        const index = this.valores_selecionados.findIndex(item => item.variacao_id === valor.variacao_id);

        if (this.valores_selecionados.some(item => item.variacao_id === valor.variacao_id)) {
          this.valores_selecionados.splice(index, 1, valor);
        } else {
          this.valores_selecionados.push(valor);
        }

        if (this.variacao_selecionada < this.produto.variacoes.length - 1) {
          this.variacao_selecionada++;
          this.variacao = this.produto.variacoes[this.variacao_selecionada];
          // this.valor_selecionado = 0;

          setTimeout(() => {
            this.onVariacaoClick(this.variacao);
          }, 10);
        }

        this.$refs.quantidade.focus();
      },
      
      removerValor(index) {
        this.valores_selecionados.splice(index, 1);
      },

      onPressESC(event) {
        if (event.key === 'Escape') {
          this.cancelar();
        }
      },

      exibirEntradas(produto) {
        this.$store.commit("produtos/SET_PRODUTO", produto);
        this.$refs.dialogoExibirEntradas.abrir();
        this.exibindoEntradas = true;
      },

      selecionaGradeDasEntradas(item) {
        // console.log({...item});
        const grade = item.grade.map(grade => {
          return {
            id: grade.id,
            descricao: grade.descricao,
            variacao_id: grade.variacao.id,
          }
        });
        this.$set(this.produto, "grade", grade);
        this.valores_selecionados = grade;

        this.variacao_selecionada = 0;
        this.variacao = this.produto.variacoes[0];
        this.onVariacaoClick(this.variacao);

        // setTimeout(() => {
        //   this.onVariacaoClick(this.variacao);
        // }, 10);
        // this.setFocus("quantidade");
      },
    },


  }
</script>

<style scoped>

</style>